<div class="lpo-dialog-container">
  <div class="lpo-header-actions">
    <div class="header-title">
      <h2>{{ isEdit ? "Edit Template" : "Create Template" }}</h2>
      <p>Configure the layout and static text for your documents.</p>
    </div>
    <div class="spacer"></div>
    <button mat-button (click)="close()" class="cancel-btn">Cancel</button>
    <button mat-raised-button color="primary" (click)="save()">
      <mat-icon>save</mat-icon> Save Template
    </button>
  </div>

  <div class="lpo-scroll-area">
    <div class="lpo-paper">
      <!-- Header -->
      <div class="receipt-header">
        <div class="brand-info">
          <div class="v-info">
            <!-- Customer Name (From) - Editable -->
            <div class="input-group">
              <input
                type="text"
                class="company-name-input"
                [(ngModel)]="data.companyName"
                placeholder="YOUR COMPANY NAME"
              />
            </div>

            <div class="input-group">
              <textarea
                class="address-input"
                rows="2"
                [(ngModel)]="data.companyDetails"
                placeholder="Your Address / Details"
              ></textarea>
            </div>

            <div class="input-row compact">
              <span class="field-label">Phno:</span>
              <input
                type="text"
                [(ngModel)]="data.phoneNumber"
                placeholder="Mobile Number"
              />
            </div>
            <div class="input-row compact">
              <span class="field-label">Telephone:</span>
              <input
                type="text"
                [(ngModel)]="data.telephoneNumber"
                placeholder="Landline Number"
              />
            </div>
            <div class="input-row compact">
              <span class="field-label">Email:</span>
              <input
                type="text"
                [(ngModel)]="data.email"
                placeholder="Email Address"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Centered Purchase Order Heading -->
      <div class="receipt-center-title">
        <h2>PURCHASE ORDER</h2>
        <div class="custom-header-text">
          <textarea
            [(ngModel)]="data.lpoHeader"
            rows="1"
            placeholder="Header Note (e.g. VAT Reg No)"
            class="header-note-input"
          ></textarea>
        </div>
      </div>

      <!-- Body: Vendor and PO Info -->
      <div class="receipt-body">
        <!-- To Vendor -->
        <div class="section-box">
          <h3>TO (Vendor)</h3>
          <div class="placeholder-box">
            <p><strong>[Vendor Name]</strong></p>
            <p>[Vendor Address]</p>
            <p>[Contact Details]</p>
          </div>
        </div>

        <!-- PO Number and Date -->
        <div class="section-box align-right">
          <h3>PO DETAILS</h3>
          <div class="placeholder-box">
            <p class="ref-no">PO Number: PO-XXXXXX</p>
            <p class="date">Date: {{ today | date: "dd MMM yyyy" }}</p>
          </div>
        </div>
      </div>

      <!-- Booking Details Section -->
      <div class="receipt-body no-margin">
        <div class="section-box full-width">
          <h3>BOOKING DETAILS</h3>
          <table class="details-table grid-2x2">
            <tr>
              <td class="label">Equipment:</td>
              <td class="value">
                <strong>[Equipment Name]</strong><br /><span class="sub-text"
                  >[Brand] [Model]</span
                >
              </td>
              <td class="label">Plate No:</td>
              <td class="value">[Plate Number]</td>
            </tr>
            <tr>
              <td class="label">Duration:</td>
              <td class="value">[Start Date] to [End Date]<br />(X days)</td>
              <td class="label">Location:</td>
              <td class="value">[Project Location]</td>
            </tr>
          </table>
        </div>
      </div>

      <!-- Financials -->
      <div class="receipt-financials">
        <table class="financial-table">
          <thead>
            <tr>
              <th>Description</th>
              <th>Rate / Type</th>
              <th class="text-right">Amount (AED)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="italic-text">Rental Charges</td>
              <td class="italic-text">AED [Rate] / [Type]</td>
              <td class="text-right italic-text">[Amount]</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="2"><strong>TOTAL AMOUNT</strong></td>
              <td class="text-right">
                <strong class="italic-text">[Total] AED</strong>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      <!-- Notes/Terms -->
      <div class="notes-section">
        <h3>Terms & Conditions</h3>
        <textarea
          class="custom-terms-edit"
          [(ngModel)]="data.lpoTerms"
          placeholder="Enter your standard Terms & Conditions here..."
        ></textarea>
      </div>

      <!-- Footer Text -->
      <div class="footer-section">
        <input
          class="footer-edit"
          type="text"
          [(ngModel)]="data.lpoFooter"
          placeholder="Optional Footer Text (e.g. Authorized Signatory)"
        />
      </div>

      <!-- Signature Section -->
      <div class="signature-section">
        <div class="sig-block">
          <!-- 1. View Mode (Signature exists) -->
          <ng-container *ngIf="data.signatureUrl; else noSig">
            <div class="signature-display">
              <img [src]="data.signatureUrl" alt="Authorized Signature" />
              <!-- Delete Button -->
              <button
                mat-icon-button
                color="warn"
                class="delete-sig-btn"
                (click)="data.signatureUrl = undefined"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </div>

            <div class="sig-box">
              <div class="line"></div>
              <p>Authorized Signature</p>
            </div>
          </ng-container>

          <!-- 2. Edit Mode (No Signature) -->
          <ng-template #noSig>
            <div class="signature-controls">
              <mat-tab-group
                [(selectedIndex)]="selectedTabIndex"
                animationDuration="0ms"
              >
                <mat-tab label="Upload Image">
                  <div class="upload-tab">
                    <button
                      mat-stroked-button
                      color="primary"
                      (click)="triggerSigInput()"
                    >
                      <mat-icon>upload</mat-icon> Upload Signature Image
                    </button>
                    <input
                      type="file"
                      id="lpoTemplateSigInput"
                      (change)="onSigSelected($event)"
                      accept="image/*"
                      hidden
                    />
                    <p class="hint">Transparent PNG recommended.</p>
                  </div>
                </mat-tab>
                <mat-tab label="Draw Signature">
                  <div class="draw-tab">
                    <div class="canvas-wrapper">
                      <canvas
                        #sigCanvas
                        width="300"
                        height="120"
                        (mousedown)="startDrawing($event)"
                        (mousemove)="draw($event)"
                        (mouseup)="stopDrawing()"
                        (mouseleave)="stopDrawing()"
                      ></canvas>
                    </div>
                    <div class="canvas-actions">
                      <button mat-button color="warn" (click)="clearCanvas()">
                        Clear
                      </button>
                      <button
                        mat-raised-button
                        color="primary"
                        (click)="saveCanvasSignature()"
                      >
                        Use Signature
                      </button>
                    </div>
                  </div>
                </mat-tab>
              </mat-tab-group>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
